export default __webpack_public_path__ + "static/William.Potter_flags_social-dc2cddcfa6c291666d401761a4041b81.jpg";